import { useEffect, useState } from 'react';
import useDebounce from '@teetsh/app/src/utils/useDebounce';
import { Planner } from '@teetsh/app/src/types/planner';
import useUpdatePlanner from '@teetsh/app/src/queries/planners/useUpdatePlanner';

export function useUpdatePlannerDebounce(
  pyr: Planner,
): [Planner, (v: Planner) => void] {
  const [planner, setPlanner] = useState<Planner>(pyr);
  const updateTrombinoscope = useUpdatePlanner({
    plannerId: pyr.id,
  });
  const debouncedSave = useDebounce(
    nextValue => updateTrombinoscope(nextValue),
    500,
  );
  useEffect(() => {
    setPlanner(pyr);
  }, [JSON.stringify(pyr)]);

  const handleChange = (v: Planner) => {
    setPlanner(v);
    debouncedSave(v);
  };
  return [planner, handleChange];
}
